export const getFirebaseConfig = () => {
	if (process.env.REACT_APP_ENV === 'prod')
		return {
			apiKey: 'AIzaSyByqeTkwomCBoGDb2mKVmeN430Vvg8iuxc',
			authDomain: 'meavana-editor-portal.firebaseapp.com',
			projectId: 'meavana-editor-portal',
			storageBucket: 'meavana-editor-portal.appspot.com',
			messagingSenderId: '735290220631',
			appId: '1:735290220631:web:93659e4362ba134a7c4312',
			measurementId: 'G-YD5WMZ5KWR'
		};
	else
		return {
			apiKey: 'AIzaSyBq5jJLaaLq0Ly0N0mlH1jJkY5QdHvImlQ',
			authDomain: 'meavana-editor-portal-dev-5467.firebaseapp.com',
			projectId: 'meavana-editor-portal-dev-5467',
			storageBucket: 'meavana-editor-portal-dev-5467.appspot.com',
			messagingSenderId: '1073453900788',
			appId: '1:1073453900788:web:10161f56cb155dec6acfa1'
		};
};
